import {h, Fragment} from "preact"
/*export function SkeletonProduct() {
    return (
        <div class="ns-skel-product ns-w-100 ns-flex ns-flex-col">
            <div class="ns-skel-img" />
            <div class="ns-skel-details ns-flex ns-flex-col">
                <div class="ns-skel-name" />
                <div class="ns-skel-price" />
            </div>
        </div>
    )
}

export function SkeletonGrid() {
    return (
        <ol 
            id="ns-product-grid" 
            class="ns-grid"
        >
            {Array.from({ length: 24 }, (_, i) => (
                <li key={i} class="ns-grid ns-block ns-w-100">
                    <SkeletonProduct />
                </li>
            ))}
        </ol>
    )
}
*/

//native:
export function SkeletonProduct() {
return (
    <li class="template-search__grid-item">
        <div class="products__listing">
        <div class="products__listing-image products__listing-image--skeleton"></div>
        <div class="products__listing-details products__listing-details--skeleton">
            <p></p><p></p><p></p>
        </div>
        </div>
    </li>
)}

export function SkeletonGrid() {
return (
    <div class="products__inner lazy-pag flex relative">
        <div class="template-search__results w-full">
            <ul class="template-search__results-grid w-full list-none grid grid-cols-2 gap-x-16 desktop:grid-cols-4 gap-y-24 desktop:gap-y-40 pl-0">
                {Array.from({ length: 24 }, (_, i) => (
                    <SkeletonProduct key={i} />
                ))}
            </ul>
        </div>
    </div>
)}